import { render, staticRenderFns } from "./CommissioningPage.vue?vue&type=template&id=16d0df0c&scoped=true"
import script from "./CommissioningPage.vue?vue&type=script&lang=js"
export * from "./CommissioningPage.vue?vue&type=script&lang=js"
import style0 from "./CommissioningPage.vue?vue&type=style&index=0&id=16d0df0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d0df0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
